import { useSelector } from "react-redux";

import { RootState } from "src/redux/reducers";
import { ProjectPermissionsEnum } from "src/utils/PermissionsEnums";

export default function useCheckProjectPermission(
  permission: keyof typeof ProjectPermissionsEnum,
) {
  const projectBasicData = useSelector(
    (state: RootState) => state.projectReducer.projectBasicData,
  );
  return Boolean(
    projectBasicData?.permissions?.project.includes(
      ProjectPermissionsEnum[permission],
    ),
  );
}
